const randRange = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1) + min)

export const createRain = (): void => {
  for (const el of document.getElementsByClassName('drop')) el.remove()

  for (let i = 0; i < 100; i++) {
    const dropTop = randRange(-1500, document.body.clientHeight / 2)
    const dropLeft = randRange(0, document.body.clientWidth)

    const catImage = document.createElement('img')
    catImage.src = 'https://fastly.mwm-storage.mwmcdn.com/raw_files/9f1d225e-69f5-4015-8e97-8d3853774a60'

    const newElement = document.createElement('div')
    newElement.id = 'drop' + i
    newElement.className = 'drop'
    newElement.appendChild(catImage)

    newElement.style.top = dropTop + 'px'
    newElement.style.left = dropLeft + 'px'
    newElement.style.animation = 'fall ' + randRange(2, 10) + 's linear infinite'
    newElement.style.zIndex = '9999'

    document.body.append(newElement)
  }
}
